import { gql } from '@urql/core';
import React from 'react';
import { SubscriptionMyPlayerCardFragment } from '../../../../generated/spin-graphql';
import { PictureWithFallback } from '../../../sections/PictureWithFallback';

type Props = {
    player: SubscriptionMyPlayerCardFragment;
    onClick: () => void;
};

gql`
    fragment SubscriptionMyPlayerCard on espin_player_profile {
        profile_image {
            ...SpinContentImageDisplay
        }
        spin_username
        first_name
        last_name
        subscription {
            expires
        }
    }
`;

export const SubscriptionMyPlayerCard: React.FC<Props> = ({ player, onClick }) => {
    return (
        <div className="my-player-card">
            <div className="image-wrapper">
                <PictureWithFallback
                    icon={player.profile_image}
                    width={60}
                    height={60}
                    alt={`${player.spin_username}} profile picture`}
                />
            </div>
            <div className="name-container">
                <h2 className="username">{player.spin_username}</h2>
                <p className="name">{`${player.first_name} ${player.last_name}`}</p>
                {player.subscription && <p className="expiry">{`Expires: ${player.subscription.expires}`}</p>}
            </div>
            <div className="subscription-container">
                {player.subscription ? (
                    <div className="player-subscription premium">Premium Account</div>
                ) : (
                    <div className="player-subscription">Free Account</div>
                )}
                <button onClick={onClick} className="button medium-button blue-button">
                    {/* {player.subscription ? 'Manage' : 'Upgrade'} */}
                    {/*  this is a much bigger task. will create new ticket to handle this stuff */}
                    Coming Soon
                </button>
            </div>
        </div>
    );
};
